export const getAcceptObjectForFilesInput = ({
  acceptImageFormats,
  acceptVideoFormats,
  acceptDocumentFormats,
  isImagesAllowed,
  isVideosAllowed,
  isDocumentsAllowed
}: {
  acceptImageFormats: string[];
  acceptVideoFormats: string[];
  acceptDocumentFormats: string[];
  isImagesAllowed: boolean;
  isVideosAllowed: boolean;
  isDocumentsAllowed: boolean;
}) => {
  const acceptObject: Record<string, string[]> = {};

  if (isImagesAllowed && acceptImageFormats.length > 0) {
    // Map extensions to their MIME types
    const imageMimeTypes: Record<string, string> = {
      ".jpeg": "image/jpeg",
      ".jpg": "image/jpeg",
      ".png": "image/png",
      ".webp": "image/webp",
      ".gif": "image/gif"
    };

    acceptImageFormats.forEach((ext) => {
      const mimeType = imageMimeTypes[ext.toLowerCase()];
      if (mimeType) {
        if (!acceptObject[mimeType]) {
          acceptObject[mimeType] = [];
        }
        acceptObject[mimeType].push(ext);
      }
    });
  }

  if (isVideosAllowed && acceptVideoFormats.length > 0) {
    const videoMimeTypes: Record<string, string> = {
      ".mp4": "video/mp4",
      ".webm": "video/webm"
    };

    acceptVideoFormats.forEach((ext) => {
      const mimeType = videoMimeTypes[ext.toLowerCase()];
      if (mimeType) {
        if (!acceptObject[mimeType]) {
          acceptObject[mimeType] = [];
        }
        acceptObject[mimeType].push(ext);
      }
    });
  }

  if (isDocumentsAllowed && acceptDocumentFormats.length > 0) {
    const documentMimeTypes: Record<string, string> = {
      ".pdf": "application/pdf",
      ".doc": "application/msword",
      ".docx":
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ".xls": "application/vnd.ms-excel",
      ".xlsx":
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    };

    acceptDocumentFormats.forEach((ext) => {
      const mimeType = documentMimeTypes[ext.toLowerCase()];
      if (mimeType) {
        if (!acceptObject[mimeType]) {
          acceptObject[mimeType] = [];
        }
        acceptObject[mimeType].push(ext);
      }
    });
  }

  return acceptObject;
};
